import { useEffect } from 'react';
import { useRezeptInit } from '@/hooks/main/useRezeptInit';
import type { RezeptInitParam } from '@/types/rezept.types';
import type { SearchState } from '../types';

interface UseRezeptInitDataArgs {
  setSearch: React.Dispatch<React.SetStateAction<SearchState>>;
}

interface UseRezeptInitDataResult {
  param: RezeptInitParam | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Fetches init defaults via useRezeptInit and seeds the local search state
 * once on arrival. Subsequent calls do not overwrite user edits.
 */
export function useRezeptInitData({ setSearch }: UseRezeptInitDataArgs): UseRezeptInitDataResult {
  const { data, isLoading, isError } = useRezeptInit();
  const param = data?.param;

  useEffect(() => {
    if (!param) return;
    setSearch(prev =>
      prev.search_yearmonth
        ? prev
        : {
            ...prev,
            search_yearmonth: param.search_yearmonth,
            search_radio: param.search_radio,
            sort_radio: param.sort_radio,
            insurer_type_id:
              prev.insurer_type_id || (param.insurer_types[0]?.id?.toString() ?? ''),
          }
    );
  }, [param, setSearch]);

  return { param, isLoading, isError };
}
